import { Locale, DEFAULT_LOCALE } from "modules/i18n/locale-config";
import constants from "common/constants";

const { BACKEND_SWEDISH_LANG_CODE } = constants;

// TODO Consider translating objects coming from backend in selectors instead of utillity method for performance reasons

/**
 * Utillity method which will extract locale specific property out of the given object based on provided locale code.
 * @param {object} objectWithLocaleSpecificProp Object which contains locale specific property.
 * @param {string} localeCode Locale defining which property of the object will be picked.
 */
export const getLocaleSpecificProp = (
  objectWithLocaleSpecificProp,
  localeCode
) => {
  // Backend use SWE code for Swedish for some reason
  // The official HTML ISO code for Swedish is SV - https://www.w3schools.com/tags/ref_language_codes.asp
  let localizedPart;
  switch (localeCode) {
    case Locale.SV.code:
      localizedPart = objectWithLocaleSpecificProp.swe;
      break;
    case Locale.EN.code:
      localizedPart = objectWithLocaleSpecificProp.en;
      break;
    default:
      localizedPart = objectWithLocaleSpecificProp[localeCode];
      break;
  }
  if (!localizedPart) {
    localizedPart = objectWithLocaleSpecificProp[DEFAULT_LOCALE.code];
  }
  return localizedPart;
};

const localesMap = {
  [BACKEND_SWEDISH_LANG_CODE]: Locale.SV.code
};

export const mapBackendLocaleToFrontendLocale = locale => {
  if (localesMap[locale]) {
    return localesMap[locale];
  }
  return locale;
};

export const mapFrontendLocaleToBackendLocale = locale => {
  for (let backendLocale in localesMap) {
    if (localesMap[backendLocale] === locale) return backendLocale;
  }
  return locale;
};



// WEBPACK FOOTER //
// ./src/modules/i18n/locale-utils.js